'use strict';
import React from 'react';
import Navbar from './navBar';
import SideMenu from './sideMenu';
import menuAction from '../actions/menuAction';
import Loading from './loading';
import filterAction from '../actions/filterAction';
import filterStore from '../stores/filterStore';
import leaveAtdStore from '../stores/leaveAtdStore';
import LeaveStaffApply from './leaveAtdComponents/leaveStaffApply';

import AtdStaffApply from './leaveAtdComponents/atdStaffApply';

class LeaveAtdApply extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.state = {
            staffs: filterStore.getState().staffs,
            processingFilter: filterStore.getState().processing,
            iniLoadStaff: filterStore.getState().iniLoadStaff,

            processing: leaveAtdStore.getState().processing,

            mode: 0
        }
    }

    componentDidMount() {
        filterStore.listen(this.onFilterChange);
        leaveAtdStore.listen(this.onChange);
        if (!this.state.processingFilter && !this.state.iniLoadStaff) {
            filterAction.processing(true);
            filterAction.getEmployee();
        }

        menuAction.pageNumber(-1);
    }
    componentWillUnmount() {
        filterStore.unlisten(this.onFilterChange);
        leaveAtdStore.unlisten(this.onChange);
    }
    handleMode(e) {
        let index = parseInt(e.target.getAttribute("data-index"));
        if (index == this.state.mode) return;

        this.setState({ mode: index });
    }
    onFilterChange(state) {
        this.setState({
            staffs: state.staffs,
            processingFilter: state.processing,
            iniLoadStaff: state.iniLoadStaff,

        });
    }
    onChange(state) {
        this.setState({
            processing: state.processing
        });
    }
    render() {
        let body = "";
        if (this.state.mode == 0) {
            body = (
                <LeaveStaffApply staffs={this.state.staffs}
                    processing={this.state.processing} />
            );
        } else {
            body = (
                <AtdStaffApply staffs={this.state.staffs}
                    processing={this.state.processing} />
            );
        }

        return (
            <div>
                <Navbar {...this.props} />
                <div className="container-fluid content">
                    <div className="row">
                        <SideMenu {...this.props} />
                        <div className=" col-md-10  col-sm-8 atd">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h4><b>Apply Leave/Attendance for Staff</b></h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="lva-b">
                                        <button className={"btn btn-default" + (this.state.mode == 0 ? " active" : "")}
                                            data-index="0" onClick={this.handleMode}>Apply Leave</button>
                                        <button className={"btn btn-default" + (this.state.mode == 1 ? " active" : "")}
                                            data-index="1" onClick={this.handleMode}>Apply Attendance</button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    {body}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Loading processing={this.state.processing || this.state.processingFilter} />
            </div >
        );
    }
}

export default LeaveAtdApply;


// WEBPACK FOOTER //
// ./app/components/leaveAtdApply.js